import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ConfirmationRequestFormBase } from '@bo-client/shared/base-components/confirmation-request-form.base';
import { Subject } from 'rxjs';
import { AuthenticationService } from '@bo-client/core';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { ErrorsFormsService } from '@bo-client/shared/form-errors/errors-forms.service';
import { CommissioningRequestDtoModel } from '@bo-client/activation-management/shared/models/commissioningRequestDto';
import { CreateFormsCrChimneysweepConfirmationService } from '@bo-client/activation-management/commissioning/forms/create-forms-cr-chimneysweep-confirmation.service';
import { CommissioningStatusEnum } from '@bo-client/activation-management/shared/models/commissioningModel';

@Component({
  selector: 'app-cr-chimneysweep-confirmation-form',
  templateUrl: './cr-chimneysweep-confirmation-form.component.html',
  styleUrls: ['./cr-chimneysweep-confirmation-form.component.scss']
})
export class CrChimneysweepConfirmationFormComponent
  extends ConfirmationRequestFormBase<CommissioningRequestDtoModel>
  implements OnInit, OnDestroy
{
  @Output() onErrorsChanged = new EventEmitter<any>();
  public compUnsubs$ = new Subject<void>();
  private commissioningRequestDto: CommissioningRequestDtoModel;

  public constructor(
    protected authenticationService: AuthenticationService,
    protected dataShareService: DataShareService,
    protected errorsFormsService: ErrorsFormsService,
    protected createFormsCrChimneysweepConfirmationService: CreateFormsCrChimneysweepConfirmationService
  ) {
    super(authenticationService, dataShareService, errorsFormsService);
  }
  ngOnInit(): void {}

  loadFormWithModel(result: CommissioningRequestDtoModel) {
    this.commissioningRequestDto = result;
    this.formGroup = this.createFormsCrChimneysweepConfirmationService.createChimneySweepForm();
  }

  hookErrors() {
    // entry Point to check specific errors
    console.log('emitting errors', this.errorFormList);
    this.onErrorsChanged.emit(this.errorFormList);
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
